import { getOrigin } from "../utils";

export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  isLoading: true,
  trackClickElement: null,
  trackOnClickStart: null,
  isExceeded: false,
  origen: getOrigin(),
  mock: null,
  sucursales: null,
  camp: process.env.VUE_APP_CAMP || "",
  // Model del paso 1
  paso1: {
    numeroSucursal: "",
    tipoTramite: "",
    fechaSolicitud: "",
    camp: process.env.VUE_APP_CAMP || ""
  },
  paso2: {
    numeroDocumento: "",
    apellido: "",
    email: "",
    nombre: "",
    razonSocial: "",
    cuit: ""
  },
  responseConfirmacion: {
    status: "",
    respuesta: {
      respuesta: "",
      datosTurnos: {
        nombre: "",
        apellido: "",
        fecha: "",
        razonSocial: "",
        cuit: "",
        cuitFormateado: "",
        sucursal: {
          id: "",
          description: "",
          address: {
            addressName: "",
            state: ""
          }
        }
      },
      randomKey: "",
      mensaje: ""
    }
  },
  datosPersonales: {
    nombre: "",
    apellido: "",
    nroDoc: "",
    tipoDoc: "0",
    email: "",
    cuit: "",
    razonSocial: ""
  },
  datosSucursal: {
    latitude: "",
    longitude: "",
    numeroSucursal: "",
    addressSucursal: "",
    citySucursal: "",
    descripcionSucursal: "",
    code: ""
  },
  tiposTramite: {
    tramites: null,
    tramiteSeleccionado: "",
    descripcionTramite: ""
  },
  fechaTurno: {
    fechasDisponibles: "",
    fechaSeleccionada: "",
    descripcionFecha: "",
    horaSeleccionada: ""
  },
  horaTurno: {
    horariosDisponibles: []
  },
  turnoAgendado: {
    pdf: "",
    urlPdf: ""
  },
  graciasPersonas: {
    pdf: "",
    urlPdf: ""
  }
};
